export const gemstones = [
  {
    id: 1,
    name: "Yellow Sapphire",
    sanskritName: "Pukhraj",
    image: "/images/yellow-sapphire.jfif",
  
  },
  {
    id: 2,
    name: "Blue Sapphire",
    sanskritName: "Neelam",
    image: "/images/blue-sapphire.jfif",
    
  },
  {
    id: 3,
    name: "Emerald",
    sanskritName: "Panna",
    image: "/images/emerald.jfif",
   
  },
  {
    id: 4,
    name: "Pearl",
    sanskritName: "Moti",
    image: "/images/pearl.jfif",
    
  },
  {
    id: 5,
    name: "Ruby",
    sanskritName: "Manik",
    image: "/images/red-coral.jfif",
    
  },
  {
    id: 6,
    name: "Diamond",
    sanskritName: "Heera",
    image: "/images/diamond.jfif",
    
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai, Maharashtra",
    rating: 5,
    text: "The birth chart analysis was incredibly accurate! AstroClick helped me understand my career path better. The gemstone recommendation has brought positive changes in my life. Highly recommended!",
    zodiac: "Leo",
    date: "January 2025"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Delhi",
    rating: 5,
    text: "I was skeptical at first, but the personalized consultation exceeded my expectations. The predictions were spot-on, and the remedies suggested were practical and effective. Thank you AstroClick!",
    zodiac: "Virgo",
    date: "December 2024"
  },
  {
    id: 3,
    name: "Anita Desai",
    location: "Bangalore, Karnataka",
    rating: 5,
    text: "The relationship compatibility reading saved my marriage! The insights were profound and the guidance was compassionate. AstroClick truly understands the ancient wisdom of astrology.",
    zodiac: "Pisces",
    date: "November 2024"
  },
  {
    id: 4,
    name: "Vikram Singh",
    location: "Jaipur, Rajasthan",
    rating: 5,
    text: "Best astrology service I've experienced. The Yellow Sapphire I purchased is certified and beautifully energized. I've noticed improvements in my financial situation. Grateful for the guidance!",
    zodiac: "Aries",
    date: "October 2024"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Your Birth Chart: A Beginner's Guide",
    excerpt: "Discover how to read the cosmic blueprint of your soul and unlock the secrets hidden in your natal chart...",
    image: "https://images.unsplash.com/photo-1532693322450-2cb5c511067d?w=600&q=80",
    date: "February 15, 2025",
    category: "Education"
  },
  {
    id: 2,
    title: "2025 Horoscope Predictions: What the Stars Hold for You",
    excerpt: "Explore the astrological trends and planetary movements that will shape your year ahead...",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80",
    date: "January 28, 2025",
    category: "Predictions"
  },
  {
    id: 3,
    title: "The Power of Gemstones: Ancient Remedies for Modern Life",
    excerpt: "Learn how wearing the right gemstone can harmonize planetary energies and bring balance to your life...",
    image: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?w=600&q=80",
    date: "January 10, 2025",
    category: "Remedies"
  },
  {
    id: 4,
    title: "Mercury Retrograde Survival Guide",
    excerpt: "Navigate communication challenges and technological mishaps during Mercury's retrograde period with ease...",
    image: "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=600&q=80",
    date: "December 20, 2024",
    category: "Guidance"
  }
];

export const services = [
  {
    id: 1,
    title: "Birth Chart Analysis",
    description: "Comprehensive reading of your natal chart revealing your personality, strengths, challenges, and life purpose.",
    icon: "stars"
  },
  {
    id: 2,
    title: "Mentorship Program",
    description: "Guiding you on your journey into Astrology with structured learning and personal support.\n\nDiscover how to begin, grow, and master Astrology with a step-by-step mentorship program designed for beginners and enthusiasts.",
    icon: "calendar"
  },
  {
    id: 3,
    title: "Relationship Compatibility",
    description: "In-depth analysis of romantic, family, or business relationships through synastry and composite charts.",
    icon: "heart"
  },
  {
    id: 4,
    title: "Career & Financial Astrology",
    description: "Guidance on career choices, business ventures, and financial decisions aligned with your cosmic blueprint.",
    icon: "briefcase"
  },
  {
    id: 5,
    title: "Vedic Remedies & Solutions",
    description: "Personalized rituals, mantras, and gemstone recommendations to balance planetary influences.",
    icon: "sparkles"
  },
  {
    id: 6,
    title: "Personalized Consultations",
    description: "One-on-one sessions addressing your specific questions and concerns with compassionate expert guidance.",
    icon: "user"
  }
];

export const whyChooseUsPoints = [
  {
    id: 1,
    title: "Accuracy Backed by Expertise",
    description: "Years of dedicated study in Vedic astrology combined with intuitive insights ensure precise predictions.",
    stat: "9+",
    statLabel: "Years Experience"
  },
  {
    id: 2,
    title: "Personalized Readings",
    description: "Every chart is unique. We provide customized guidance tailored to your individual cosmic signature.",
    stat: "5000+",
    statLabel: "Happy Clients"
  },
  {
    id: 3,
    title: "Confidential & Compassionate",
    description: "Your privacy is sacred. Our consultations are conducted with empathy, respect, and complete confidentiality.",
    stat: "100%",
    statLabel: "Confidential"
  },
  {
    id: 4,
    title: "Ancient Wisdom, Modern Tools",
    description: "We honor traditional Vedic techniques while leveraging advanced astrological software for precision.",
    stat: "24/7",
    statLabel: "Support Available"
  }
];

export const contactInfo = {
  phone: "+91 8209130889",
  email: "astroclick10@gmail.com",
  whatsapp: "918209130889",
  address: "India",
  // hours removed per request
};

export const socialLinks = {
  instagram: "https://www.instagram.com/_astroclick_/",
  whatsapp: "https://whatsapp.com/channel/0029Vb4pk2S30LKLw2xjVC3e",
  youtube: "https://www.youtube.com/@astroclick_"
};